import React, { useState } from "react";
import "./SearchableSelect.css";

const SearchableSelect = ({ options, placeholder = "Select Any One" }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setSearchTerm(""); // Reset search term after selection
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const filteredOptions =
    searchTerm.length >= 2
      ? options.filter((option) =>
          option.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : [];

  return (
    <div className="select-box">
      <div className="select-box-header form-control input-lg" onClick={toggleDropdown}>
        {selectedOption || placeholder}
        <span className="select-box-arrow">▼</span>
      </div>
      {isOpen && (
        <div className="select-box-dropdown">
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            className="select-box-search"
            placeholder="Type to search..."
          />
          {searchTerm.length < 2 ? (
            <div className="select-box-message">
              Please enter 2 or more characters
            </div>
          ) : (
            <ul className="select-box-options">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <li
                    key={index}
                    className="select-box-option"
                    onClick={() => handleOptionClick(option)}
                  >
                    {option}
                  </li>
                ))
              ) : (
                <li className="select-box-no-option">No options found</li>
              )}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
